import { Link } from "react-router-dom";
import { Accordion, AccordionItem, AccordionTrigger, AccordionContent } from "@/components/ui/accordion";
import { FAQS } from "@/lib/faqData";
import { sb } from "@/lib/text";

export function FaqSection({ limit, showAllLink = false, id = "faq" }) {
  const items = limit ? FAQS.slice(0, limit) : FAQS;
  return (
    <section id={id} className="max-w-3xl mx-auto px-5 py-16" data-testid="faq-section">
      <div className="text-center">
        <h2 className="font-display font-bold text-3xl tracking-tight">Domande frequenti</h2>
        <p className="mt-3 text-slate-500">Tutto quello che c'è da sapere su StayGuide.</p>
      </div>
      <Accordion type="single" collapsible className="mt-8 space-y-3">
        {items.map((f, i) => (
          <AccordionItem key={i} value={`faq-${i}`} data-testid={`faq-item-${i}`}
            className="border border-slate-200 rounded-2xl px-5 bg-white">
            <AccordionTrigger className="text-left font-semibold text-slate-900 py-4 hover:no-underline">{f.q}</AccordionTrigger>
            <AccordionContent className="text-slate-600 pb-4 leading-relaxed text-[15px]">{sb(f.a)}</AccordionContent>
          </AccordionItem>
        ))}
      </Accordion>
      {showAllLink && (
        <div className="text-center mt-7">
          <Link to="/faq" data-testid="faq-see-all" className="inline-flex items-center gap-1.5 text-blue-600 font-semibold">Vedi tutte le domande →</Link>
        </div>
      )}
    </section>
  );
}
